<div class="modal-cancel">
  <div class="modal-cancel__title">
    <h2>{{ 'MODAL_WARNING_DIALOG.CANCEL_TITLE' | i18nextEager }}</h2>
  </div>
  <span *ngIf="data?.subtitle" class="text">{{ data.subtitle | i18nextEager }}</span>
  <div class="modal-cancel__buttons">
    <button class="secondary" (click)="handleCancel(false)">
      {{ 'COMMONS.BACK' | i18nextEager }}
    </button>
    <button (click)="handleCancel(true)">
      {{ 'COMMONS.OK' | i18nextEager }}
    </button>
  </div>
</div>
